/**
 * RiderStatusPage Helpers
 * 라이더 현황 페이지 헬퍼 함수 및 상수
 */

/**
 * 테이블 컬럼 정의
 */
export interface TableColumn {
    key: string;
    header: string;
}

/**
 * 테이블 컬럼 목록
 */
export const TABLE_COLUMNS: TableColumn[] = [
    { key: 'id', header: 'Vpay 라이더ID' },
    { key: 'supplierName', header: '협력사명' },
    { key: 'name', header: '이름' },
    { key: 'riderTypeName', header: '라이더구분' },
    { key: 'balAmt', header: '보유잔액' },
    { key: 'registNum', header: '주민등록번호' },
    { key: 'phoneNumber', header: '휴대폰번호' },
    { key: 'preAcctYn', header: '선정산' },
    { key: 'joinDate', header: '등록일자' },
    { key: 'contractEndDate', header: '계약종료일자' },
];

/**
 * 총 컬럼 수 (colspan 계산용)
 */
export const TOTAL_COLUMN_COUNT = 10;

/**
 * 라이더 구분 코드 -> 명칭 변환
 */
export const getRiderTypeName = (riderType: string | null | undefined): string => {
    if (!riderType || riderType === 'GENERAL') return '일반';
    if (riderType === 'BRANCH_MANAGER') return '지점장';
    if (riderType === '65_YEARS_AGE') return '만65세이상';
    return '일반';
};

/**
 * 잔액 포맷팅 (원화)
 */
export const formatBalance = (amount: number | null | undefined): string => {
    if (amount === null || amount === undefined) return '0원';
    return `${amount.toLocaleString()}원`;
};

/**
 * 필터 필드 정의
 */
export interface FilterField {
    key: string;
    label: string;
    type: 'text' | 'select';
}

/**
 * 기본 필터 필드 목록 (협력사/본사 공통)
 */
export const COMMON_FILTER_FIELDS: FilterField[] = [
    { key: 'riderName', label: '이름', type: 'text' },
    { key: 'riderId', label: '아이디', type: 'text' },
    { key: 'phoneNum', label: '휴대폰 번호', type: 'text' },
];

/**
 * 값이 없을 때 기본값 반환
 */
export const getDisplayValue = (value: string | null | undefined): string => {
    return value || '-';
};
